import { IPhoneNumber } from '../redux/reducers';

export const getPhone = (phoneObject: IPhoneNumber | null | undefined): string | null => {
  if (!phoneObject) {
    return null;
  }

  return  `${phoneObject.countryCode}${phoneObject.number}`;
};
